import { useTranslation } from "react-i18next";
import useClientConfig from "../hooks/clientConfigHook";
import { useNetworkState } from "../hooks/appStateHook";

const OfflineMask = ({ supportsOffline }) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const { wsStatus } = useNetworkState();


    return wsStatus !== 'authenticated' && (!supportsOffline || !clientConfig.enableOfflineMode) && <div style={{ zIndex: 100, opacity: 0.7, backgroundColor: 'white', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 20}}><span style={{ opacity: 1 }}>{t('onlineOnlyMessage')}</span></div>
}

export default OfflineMask